import { faker } from '@faker-js/faker';
import { axiosMock } from '@api/client';
import { API_URL } from '@api/apiDictionary';
import { SeriesStatus, SeriesType, QCVisitWithSeries } from '@dynamika-shared/types/visits';

export const randomQCTaskSeries: () => QCVisitWithSeries = () => ({
  visitId: faker.string.uuid(),
  visitDefinitionId: faker.string.uuid(),
  studyInstanceUid: faker.string.uuid(),
  studyId: faker.string.uuid(),
  id: faker.string.uuid(),
  dicomSeries: [
    {
      id: faker.string.uuid(),
      seriesInstanceUid: faker.string.uuid(),
      labelId: faker.string.uuid(),
      acquisitionDate: faker.date.recent().toISOString(),
      hidden: faker.datatype.boolean(),
      referenceId: faker.string.uuid(),
      seriesType: faker.string.fromCharacters([
        'UPLOADED',
        'GENERATED',
        'REPORT',
      ]) as SeriesType,
      status: faker.string.fromCharacters([
        'READY',
        'UPLOADED',
      ]) as SeriesStatus,
    },
  ],
});

const generateResponse = (number: number) => {
  return new Array(number).fill(undefined).map(randomQCTaskSeries);
};

export const fetchQCTaskSeriesMock = async (taskId: string) => {
  const data = {
    visits: generateResponse(faker.number.int({ min: 1, max: 3 })),
  };
  axiosMock
    .onGet(API_URL.qcTaskComments.replace(':taskId', taskId))
    .reply(200, data);
  axiosMock.onGet(API_URL.qcTaskComments.replace(':taskId', taskId));
};
